import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { FiShoppingCart } from "react-icons/fi"

import RenderCartCourses from "./RenderCartCourses"
import RenderTotalAmount from "./RenderTotalAmount"

export default function Cart() {
  const { total, totalItems } = useSelector((state) => state.cart)
  const navigate = useNavigate()

  return (
    <div className="pb-10">
      {/* Header */}
      <div className="mb-6 flex items-center gap-3">
        <h1 className="text-2xl font-bold text-richblack-5">My Cart</h1>
        {totalItems > 0 && (
          <span className="rounded-full bg-yellow-50/10 px-2.5 py-0.5 text-xs font-semibold text-yellow-50">
            {totalItems} {totalItems === 1 ? "course" : "courses"}
          </span>
        )}
      </div>

      {total > 0 ? (
        <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
          {/* Course list */}
          <div className="flex-1 min-w-0">
            <RenderCartCourses />
          </div>
          {/* Order summary — sticky on desktop */}
          <div className="w-full lg:w-[320px] lg:sticky lg:top-6 flex-shrink-0">
            <RenderTotalAmount />
          </div>
        </div>
      ) : (
        /* Empty state */
        <div className="flex flex-col items-center justify-center rounded-2xl border border-richblack-700 bg-richblack-800 py-20 text-center">
          <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-richblack-700">
            <FiShoppingCart className="text-3xl text-richblack-400" />
          </div>
          <p className="text-lg font-semibold text-richblack-100">Your cart is empty</p>
          <p className="mt-1 text-sm text-richblack-400">Browse courses and add them to your cart</p>
          <button
            onClick={() => navigate("/catalog")}
            className="mt-6 rounded-lg bg-yellow-50 px-5 py-2 text-sm font-semibold text-richblack-900 transition-all hover:bg-yellow-100 active:scale-95"
          >
            Explore Courses
          </button>
        </div>
      )}
    </div>
  )
}
